module.exports = __webpack_public_path__ + "img/casas_ga.6973557d.jpg";